<!-- <div class="pt-4 chart-container contentCenter col"> -->
  <div>{{ chartId }}</div>
  <canvas 
  [ngClass]="{'canvasstylechart': chartId !== 'pie', 'pie-chart-class': chartId === 'pie'}" 
  [id]="chartId">
</canvas>
  <!-- </div> -->